export class GetPayrollValidation {
	static readonly type = '[PayrollValidation] Get';
	constructor(public borrowerId: number) {}
}

export class ClearPayrollValidation {
	static readonly type = '[PayrollValidation] ClearBorrowerValues';
	constructor(public borrowerId: number) {}
}

export class CreatePayrollValidation {
	static readonly type = '[PayrollValidation] Create';
	constructor(public pppValidationDocuments: any) {}
}
